import endpoint from "../../config/endpoints";

export const AllowanceWiseClaimUpdateJson = {
    showSaveNextBtn: true,
    apiBaseURL: endpoint.stockStakeholderOrderHeader,
    screenTitle: "Allowance Wise Claim",
    fieldMeta: [
        {
            label: "From Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 5,
            lg: 5,
            sm: 5,
            xs: 12,
            dataKey: "fromDate",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "toDate-le",
        },
        {
            label: "To Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 5,
            lg: 5,
            sm: 5,
            xs: 12,
            dataKey: "toDate",
            onSubmit: "compare",
            onSubmitParameter: "fromDate-ge",
            isMandatory: true,
            onSubmit: "compare",
        },
    ],
};
